import React, { useState } from "react";
import { Link } from "react-router-dom";
import { List, CheckCircle2 } from "lucide-react";
import { PageHeader } from "../components/kit";
import ProductForm from "../components/ProductForm";
import { tk, bn } from "../lib/format";

export default function ProductNew() {
  const [added, setAdded] = useState<any[]>([]);
  return (
    <div>
      <PageHeader title="নতুন পণ্য যোগ" subtitle="শুধু নাম আর দর দিলেই চলবে — বাকিগুলো পরে দিতে পারবেন" actions={<Link to="/products" className="btn btn-ghost" data-testid="product-new-list-link"><List size={17} /> পণ্য তালিকা</Link>} />
      <div className="card p-5 md:p-6">
        <ProductForm onSaved={(p) => setAdded((a) => [p, ...a])} />
      </div>
      {added.length > 0 && (
        <div className="card mt-4 p-4" data-testid="recently-added-products">
          <p className="text-sm font-semibold text-slate-600 mb-2">এইমাত্র যোগ হয়েছে ({bn(added.length)})</p>
          <ul className="space-y-1.5">
            {added.map((p) => (
              <li key={p.id} className="flex items-center gap-2 text-sm">
                <CheckCircle2 size={16} className="text-emerald-600" /> <b>{p.name}</b> · {tk(p.rate)} · স্টক {bn(p.stock)} {p.unit}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
